import { CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { useStyles } from "./styles";

// Viewport minus the top bar, breadcrumb and action row of a list screen.
export const LIST_TABLE_SCROLL_HEIGHT = "calc(100vh - 200px)";

type ScrollableViewProps = {
  height?: number | string;
  loadMore: () => void;
  hasMoreItems: boolean;
  children: ReactNode;
  borderless?: boolean;
};

export const ScrollableView: React.FC<ScrollableViewProps> = ({
  height,
  loadMore,
  hasMoreItems,
  children,
  borderless = false,
}) => {
  const styles = useStyles();
  const loader = (
    <div key="loader" className={styles.dataTableDiv}>
      <CircularProgress style={{ width: "10px", height: "10px" }} /> Loading ...
    </div>
  );
  return (
    <div
      className={
        borderless ? styles.dataTableDivBorderless : styles.dataTableDiv
      }
      style={{ height: height || "auto" }}
    >
      <InfiniteScroll
        loadMore={loadMore}
        hasMore={hasMoreItems}
        loader={loader}
        useWindow={false}
      >
        <div className={borderless ? styles.UIBorderless : styles.UI}>
          {children}
        </div>
      </InfiniteScroll>
    </div>
  );
};
